// extracted by mini-css-extract-plugin
export default {"primary-btn":"PrimaryButton_primary-btn__01F2H"};